// import Swiper core, modules, and css
import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules'; // import Swiper modules (if needed). Full list here: https://swiperjs.com/swiper-api#modules
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

import { FocusPointsRevealer } from './deps/FocusPointsRevealer'
import { ModalManager } from './deps/ModalManager'

import { Expandable } from "./../../js/Expandable";
import { SplitText } from "./../../js/SplitText";

import './index.scss'

class TTSHotspotsV2 {
    constructor(el) {
        // console.log('TTSHotspotsV2::constructor')
        this.$el = el
        
        // this.focusPointsSelector = '.focus-point'
        this.focusPointsSelector = '[data-focus-point]' // temp
        
        this.transitionDuration = 2 // in seconds
        
        this.isAnimating = false
    }
    init() {
        // console.log('TTSHotspotsV2::init')
        this.$el.classList.add('init')
        
        this.initSwiper()
        this.initFocusPointsRevealer()
        this.initModalManager()
        
        this.setFocusPointsListeners()
        
        this.initIntro()
    }
    initIntro() {
        this.tweens = {}
        this.introTitle = new SplitText(this.$el.querySelector('.acf-tts-hotspots__intro__title'), { 
            splitChars: true, 
            debug: false,
        })
        
        new Expandable( '#hotspots-intro', {
            on: {
                close: (region) => {
                    region.setAttribute('inert', 'inert')
                    this.introDisappear()
                },
                open: (region) => {
                    region.removeAttribute('inert')
                    this.modalManager.close()
                    this.focusPointsRevealer.focus('idle')
                    this.introAppear()
                }
            }
        } )
    }
    introAppear() {
        this.$el.dataset.mode = 'intro'
        // reveal title
        if (this.timeline) this.timeline.kill()
        this.timeline = gsap.timeline()
            .fromTo(this.introTitle.chars, {
                yPercent: 100,
                opacity: 0,
            }, {
                yPercent: 0,
                stagger: 0.05,
                ease: "power2",
                delay: this.transitionDuration / 2,
                duration: this.transitionDuration / 2 * 0.6,
                opacity: 1,
            })
            .fromTo(this.$el.querySelectorAll('.acf-tts-hotspots__intro__text, .acf-tts-hotspots__intro__cta'), {
                opacity: 0,
            }, {
                opacity: 1,
                ease: 'power2.in',
                // delay: this.transitionDuration / 2,
                duration: this.transitionDuration / 2 * 0.3,
                delay: this.transitionDuration * 0.3,
            }, '<')
        const dotsVisible = this.$el.dataset.modalState !== 'open'
        // dotsDisappear
        if (dotsVisible) this.hideDots()
    }
    hideDots() {
        if (this.dotsTween) this.dotsTween.kill()
        this.dotsTween = gsap.to(this.$el.querySelectorAll('[data-focus-point]'), {
            ease: "power2",
            duration: this.transitionDuration / 2 * 0.6,
            opacity: 0,
            scale: 0,
        })
    }
    introDisappear() {
        this.$el.dataset.mode = 'hotspots'
        // hide title
        if (this.timeline) this.timeline.kill()
        this.timeline = gsap.timeline()
            .fromTo(this.introTitle.chars, {
              yPercent: 0,
              opacity: 1
            }, {
              yPercent: -100,
              stagger: 0.05,
              ease: "power2",
              duration: this.transitionDuration / 2 * 0.6,
              opacity: 0,
            })
            .fromTo(this.$el.querySelectorAll('.acf-tts-hotspots__intro__text, .acf-tts-hotspots__intro__cta'), {
                opacity: 1,
            }, {
                opacity: 0,
                duration: this.transitionDuration / 2 * 0.3,
            }, '<')
        this.showDots(1)
    }
    showDots(delay) {
        if (this.dotsTween) this.dotsTween.kill()
        this.dotsTween = gsap.fromTo(this.$el.querySelectorAll('[data-focus-point]'), {
            opacity: 0,
            scale: 3,
        }, {
            stagger: 0.08,
            ease: "power2",
            delay: delay,
            duration: this.transitionDuration / 2 * 0.6,
            opacity: 1,
            scale: 1,
        })
    }
    initSwiper() {
        this.swiper = new Swiper(this.$el.querySelector('.acf-tts-hotspots__swiper'), {
            modules: [FreeMode],
            slidesPerView: 'auto',
            speed: 1000,
            watchOverflow: true,
            freeMode: {
                enabled: true,
                sticky: false,
                momentumBounce: false,
            },
            grabCursor: true,
            centerInsufficientSlides: true,
            on: {
                init: function (swiper) {
                    // console.log('swiper::init')
                },
                // click: function () {
                //     console.log('swiper::click')
                // },
                lock: function (swiper) {
                    // console.log('swiper::lock')
                    document.querySelector('.acf-tts-hotspots .interact-invite--hr-swipe').style.display = 'none'
                    document.querySelector('.acf-tts-hotspots .interact-invite--click').style.display = 'flex'
                    swiper.unsetGrabCursor()
                },
                unlock: function (swiper) {
                    // console.log('swiper::unlock')
                    document.querySelector('.acf-tts-hotspots .interact-invite--hr-swipe').style.display = 'flex'
                    document.querySelector('.acf-tts-hotspots .interact-invite--click').style.display = 'none'
                    swiper.setGrabCursor()
                }
            },
            resistanceRatio: 0,
        })
        // console.log(this.swiper)
    }
    initFocusPointsRevealer() {
        this.focusPointsRevealer = new FocusPointsRevealer(this.$el)
        
        this.focusPointsRevealer.render() // focus('idle') but without tweening
        
        this.focusPointsRevealer.registerFocusPointsBySelector(this.focusPointsSelector)
    }
    initModalManager() {
        this.modalManager = new ModalManager(this.$el, this.focusPointsSelector)
        
        this.modalManager.$closeBtn.addEventListener('click', () => {
            this.scrollToTop()
            // this.resetSwiperPosition()
            this.modalManager.close()
            this.focusPointsRevealer.focus('idle')
            this.swiper.enable()
            this.showDots(2)
        }, {capture: false, passive: true, once: false} || false)
        
        this.modalManager.$prevBtn.addEventListener('click', () => {
            this.scrollToTop()
            // this.resetSwiperPosition()
            this.modalManager.prev()
            this.focusPointsRevealer.focus(this.modalManager.currentID)
        }, {capture: false, passive: true, once: false} || false)
        
        this.modalManager.$nextBtn.addEventListener('click', () => {
            this.scrollToTop()
            // this.resetSwiperPosition()
            this.modalManager.next()
            this.focusPointsRevealer.focus(this.modalManager.currentID)
        }, {capture: false, passive: true, once: false} || false)
    }
    setFocusPointsListeners() {
        this.$el.querySelectorAll(this.focusPointsSelector).forEach($dot => {
            $dot.addEventListener('click', () => {
                this.swiper.disable()
                this.hideDots()
                const focusPointName = $dot.dataset.name
                // console.log('kiliko on focusPoint', focusPointName, this.focusPointsRevealer.focusPoints[focusPointName])
                
                this.scrollToTop()
                this.resetSwiperPosition()
                
                this.focusPointsRevealer.focus(focusPointName)
                if ($dot.dataset.name !== 'idle') this.modalManager.open($dot.dataset.name)
            }, {capture: false, passive: true, once: false} || false)
        })
    }
    resetSwiperPosition() {
        if (window.innerWidth <= 767) {
            // translate to center
            this.swiper.translateTo(this.swiper.maxTranslate() / 2, this.transitionDuration * 1000, true, true)
        } else {
            // translate to left
            this.swiper.translateTo(0, this.transitionDuration * 1000, false, true)
            // console.log('swiper.translate', this.swiper.translate)
        }
    }
    scrollToTop() {
        // gsap.to(window, {
        //     scrollTo: this.$el
        // })
        window.scrollTo(0, 0)
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-tts-hotspots') ].forEach($block => {
        $block.expandygg = new TTSHotspotsV2($block)
    })
}, {capture: false, passive: true, once: true} || false)
